import { useDecision } from '@optimizely/react-sdk';

import { useFaviconBadge } from './useFaviconBadge';
import { useUnreadCount } from './useUnreadCount';

export function useNotificationFavicon() {
  const [decision] = useDecision('notifications');
  const enabled = decision.enabled;

  const { data: unreadCount } = useUnreadCount({ enabled });

  useFaviconBadge(enabled && (unreadCount ?? 0) > 0);
}
